import {
	Snackbar,
	Alert,
	ThemeProvider
  } from '@mui/material';
  import { useState, useEffect } from 'react';
  import { useSearchParams } from 'react-router-dom';
  import HireAgreementForm from './lib/HireAgreement/HireAgreementForm';
  import theme from '../theme/theme';
  import hireAgreementCrud from './lib/HireAgreement/hireAgreement.crud';
  
  const capchaKey = process.env.REACT_APP_FORM_CAPTCHA_KEY;
  
  export default function HireAgreement() {
	const [messageState, setMessageState] = useState({
	  message: '',
	  open: false,
	  severity: 'success'
	});
	const toApiUrl = (pathname) =>
		`${process.env.REACT_APP_PATH_NAME}${pathname}`;
	const [searchParams] = useSearchParams();
	const [initialValues, setInitialValues] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const crud = hireAgreementCrud(toApiUrl);
  
	useEffect(() => {
	  (async () => {
		try {
		  const parsed = {};
		  searchParams.forEach((value, key) => {
			try {
			  if (['area_names', 'sub_area_names', 'hiring_days'].includes(key)) {
				parsed[key] = value.split(',').map(v => v.trim());
			  } else if (['start_date', 'end_date'].includes(key)) {
				parsed[key] = value;
			  } else if (['spectators', 'total_attendance'].includes(key)) {
				parsed[key] = parseInt(value, 10);
			  } else if (key === 'is_charging_attendance' || 
						key === 'continues_school_holidays' || 
						key === 'has_booking_exceptions') {
				parsed[key] = value === '1' ? '1' : '0';
			  } else if (key === 'documents_names') {
				parsed[key] = value;
			  } else {
				parsed[key] = value;
			  }
			} catch (err) {
			  console.error(`Error parsing parameter ${key}:`, err);
			  parsed[key] = value;
			}
		  });
  
		const allParams = Object.fromEntries(searchParams.entries());
		const validate = await crud.validateForm(allParams);
		 
		  if (!validate.data.valid) {
			setMessageState({
			  message: 'Invalid form link. Please contact the administrator.',
			  open: true,
			  severity: 'error'
			});
			setIsLoading(false);
			return;
		  }
  
		  setInitialValues(parsed);
		  setIsLoading(false);
		} catch (err) {
		  setMessageState({
			message: err.message || 'Failed to parse form data.',
			open: true,
			severity: 'error'
		  });
		  setIsLoading(false);
		}
	  })();
	}, [searchParams]);
  
	const handleMessageClose = () =>
	  setMessageState(s => ({ ...s, open: false }));

  
	return (
	  <ThemeProvider theme={theme}>
		<div className="min-h-screen bg-gradient-to-br from-[#2196F3] to-[#1976D2] p-2 sm:p-5">
		  {/* … background floats … */}
		  <div className="w-full max-w-full md:max-w-[900px] mx-auto bg-white rounded-[20px] shadow-lg overflow-hidden relative">
			{/* … header … */}
			<div className="p-2 sm:p-6 md:p-12">
			  <div className="flex flex-col justify-between items-center mb-3 sm:mb-5 gap-2 sm:gap-0">
				<h1 className="text-xl sm:text-2xl font-bold">Hire Agreement</h1>
				<p className="text-xs sm:text-sm text-gray-500 text-center sm:text-left">Please accept the terms and conditions and sign the agreement below.</p>
			  </div>
			  {isLoading ? (
				<div className="flex justify-center items-center h-40 sm:h-64">
				  <div className="animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-b-2 border-blue-500" />
				</div>
			  ) : initialValues ? (
				<HireAgreementForm
				  toApiUrl={toApiUrl}
				  capchaKey={capchaKey}
				  summaryMode={true}
				  initialValues={initialValues}
				  editMode={true}
				/>
			  ) : (
				<div className="flex justify-center items-center min-h-[100px]">
				  <Alert severity="error" className="w-full text-xs sm:text-sm">
					Unable to load form data. The link may have expired or is invalid.
				  </Alert>
				</div>
			  )}
			</div>
		  </div>
  
		  <Snackbar
			open={messageState.open}
			autoHideDuration={6000}
			onClose={handleMessageClose}
		  >
			<Alert
			  onClose={handleMessageClose}
			  severity={messageState.severity}
			>
			  {messageState.message}
			</Alert>
		  </Snackbar>
		</div>
	  </ThemeProvider>
	);
  }
  